import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { Focusable } from "@xo-union/ui-accessibility";
import { useLinkProps } from "../../utilities/index.js";

/**
 * Render a native link as the interactive container to a `NonInteractiveButton`
 *
 * ref is passed to underlying link
 */
const LinkContainer = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    as: Type,
    children,
    ...ownProps
  } = _ref;
  const finalProps = useLinkProps(ownProps, true);
  return /*#__PURE__*/React.createElement(Focusable, _extends({
    as: Type,
    ref: ref
  }, finalProps), children);
});
process.env.NODE_ENV !== "production" ? LinkContainer.propTypes = {
  /**
   * Disable link. Removes interactivity and hrefs
   */
  disabled: PropTypes.bool,
  /**
   * Link href. Removed if disabled
   */
  href: PropTypes.string,
  /**
   * Alternative prop to pass href to components that understand the `to` prop
   * (Such as `react-router`s `Link`)
   */
  to: PropTypes.string,
  /**
   * Component or element to render
   */
  as: PropTypes.elementType,
  /**
   * The button's content
   */
  children: PropTypes.node,
  /**
   * Click handler. Not required for links.
   */
  onClick: PropTypes.func,
  /**
   * Add additional classes
   */
  className: PropTypes.string,
  /**
   * Force active state
   */
  active: PropTypes.bool
} : void 0;
LinkContainer.defaultProps = {
  as: 'a'
};
LinkContainer.displayName = 'LinkContainer';
export default LinkContainer;